export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {

};

export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    'background' : imgsPath + "reels/reels_background_{q}.png",
    'reels_cover' : imgsPath + "reels/reels_cover_{q}.png",
    'logo_reels' : imgsPath + "reels/logo_reels_{q}.png",
    'cross' : imgsPath + "reels/cross_{q}.png",

    'reels_lights' : imgsPath + "reels/lights-on_{q}.png",

    'winline_left' : imgsPath + "reels/winline_left_{q}.png",
    'winline_right' : imgsPath + "reels/winline_right_{q}.png",

    'settings_background_1'	: imgsPath + 'infos/settings_background_1_{q}.png',
    'settings_background_2'	: imgsPath + 'infos/settings_background_2_{q}.png',
    'settings_background_3'	: imgsPath + 'infos/settings_background_3_{q}.png',
    'settings_background_4'	: imgsPath + 'infos/settings_background_4_{q}.png',

    'symbol_X2'			:	imgsPath + 'symbols/symbol_X2/symbol_X2_sprite_{q}.png',
    'symbol_X4'			:	imgsPath + 'symbols/symbol_X4/symbol_X4_sprite_{q}.png',
    'symbol_X8'			:	imgsPath + 'symbols/symbol_X8/symbol_X8_sprite_{q}.png',

    'symbol_X2_long'		:	imgsPath + 'symbols/symbol_X2_long/symbol_X2_long_sprite_{q}.png',
    'symbol_X4_long'		:	imgsPath + 'symbols/symbol_X4_long/symbol_X4_long_sprite_{q}.png',
    'symbol_X8_long'		:	imgsPath + 'symbols/symbol_X8_long/symbol_X8_long_sprite_{q}.png',

    'symbol_Wild_short'	:	imgsPath + 'symbols/symbol_Wild_short/symbol_Wild_short_sprite_{q}.png',

    'bigwin_sprite' : imgsPath + 'bigwin/bigwin_sprite_{q}.png',
    'bigwin' : imgsPath + 'bigwin/bigwin_{q}.png',
    'megawin' : imgsPath + 'bigwin/megawin_{q}.png',
    'supermegawin' : imgsPath + 'bigwin/supermegawin_{q}.png',
};

export const to_load_audio = {
    'BIG_WIN'				: audioPath + "bwin_BigWin.ogg",
    'MEGA_WIN'				: audioPath + "bwin_MegaWin.ogg",
    'SUPER_MEGA_WIN'		: audioPath + "bwin_SuperMegaWin.ogg",

    'reels'					: audioPath + "reel_Spin.ogg",

    'pre_reels'				: audioPath + "reel_Start.ogg",

    'REEL_STOP'				: audioPath + "reel_Stop.ogg",

    'WIN_LINE_7'			: audioPath + "win_7.ogg",
    'WIN_LINE_7_wild'		: audioPath + "win_7_Wild.ogg",
    'WIN_LINE_symb'			: audioPath + "win_Symbol.ogg",
    'WIN_LINE_symb_WILD'	: audioPath + "win_Symbol_Wild.ogg",
    'X2'					: audioPath + "win_Multiplier_x2.ogg",
    'X4'					: audioPath + "win_Multiplier_x4.ogg",
    'X8'					: audioPath + "win_Multiplier_x8.ogg",
    'Jackpot_sound'			: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
    'JokerBonus_alert' : assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",

    'wild'					: audioPath + "symbol_Wild.ogg"
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'font_bigwin_mobile' :	{
        img:	imgsPath + 'fonts/font_bigwin_mobile-export.png',
        xml:	imgsPath + 'fonts/font_bigwin_mobile-export.xml',
    },
    'font_menu_mobile' :	{
        img:	imgsPath + 'fonts/font_menu_mobile-export.png',
        xml:	imgsPath + 'fonts/font_menu_mobile-export.xml',
    },
    'font_wintables_mobile' :	{
        img:	imgsPath + 'fonts/font_wintables_mobile-export.png',
        xml:	imgsPath + 'fonts/font_wintables_mobile-export.xml',
    }
};

import {
    madnes_audio_allow_multiple,
    madnes_audio_levels,
    madnes_set_audio_volume
} from "../../framework/src/engine/madnes/madnes_audio";
import {systemConfig, to_load_audio_madnes} from "../../framework/src/engine/madnes/madnes_variables";

export function set_sounds(server_config)
{
    if(typeof server_config.volume.bigWin != "undefined")
    {
        madnes_set_audio_volume('BIG_WIN', server_config.volume.bigWin);
        madnes_set_audio_volume('MEGA_WIN', server_config.volume.bigWin);
        madnes_set_audio_volume('SUPER_MEGA_WIN', server_config.volume.bigWin);
    }
    if(typeof server_config.volume.buttonEffect != "undefined")
    {
        madnes_set_audio_volume('button_click', server_config.volume.buttonEffect);
    }
    if(typeof server_config.volume.spin != "undefined")
    {
        madnes_set_audio_volume('reels', server_config.volume.spin);
    }
    if(typeof server_config.volume.startReel != "undefined")
    {
        madnes_set_audio_volume('pre_reels', server_config.volume.startReel);
    }
    if(typeof server_config.volume.stopReel != "undefined")
    {
        madnes_set_audio_volume('REEL_STOP', server_config.volume.stopReel);
        madnes_audio_allow_multiple('REEL_STOP');
    }
    if(typeof server_config.volume.winAnim != "undefined")
    {
        madnes_set_audio_volume('WIN_LINE_7', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_7_wild', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_symb', server_config.volume.winAnim);
        madnes_set_audio_volume('WIN_LINE_symb_WILD', server_config.volume.winAnim);
        madnes_set_audio_volume('X2', server_config.volume.winAnim);
        madnes_set_audio_volume('X4', server_config.volume.winAnim);
        madnes_set_audio_volume('X8', server_config.volume.winAnim);
    }
    if(typeof server_config.volume.winCounter != "undefined")
    {
        madnes_set_audio_volume('remittance_A', server_config.volume.winCounter);
        madnes_set_audio_volume('remittance_B', server_config.volume.winCounter);
    }
    if(typeof server_config.miscSounds.miscSounds1 != "undefined")
    {
        madnes_set_audio_volume('coins_loop', server_config.miscSounds.miscSounds1);
    }
    if(typeof server_config.miscSounds.miscSounds2 != "undefined")
    {
        madnes_set_audio_volume('wild', server_config.miscSounds.miscSounds2);
    }
    for(var i in to_load_audio_madnes)
    {
        if(typeof madnes_audio_levels[i] == "undefined")
        {
            console.log("Not set " + i);
        }
    }
}
